const R = require('ramda');
const { theme } = require('@cowsquare/design');

const projectTheme = {
  album: {
    cover: { backgroundColor: '#e8e8e8' },
    date: { color: theme.colors.blacks[4] },
  },
  photo: {
    dateAndLocation: { color: theme.colors.blacks[6] },
    desc: { color: theme.colors.blacks[4] },
  },
};

export default R.mergeDeepRight(theme, projectTheme);
